import { PeopleTaskActionModal, type PeopleTaskPrefill } from "@/components/mirror/PeopleTaskActionModal";
import { ExternalTaskActionModal } from "@/components/mirror/ExternalTaskActionModal";
import type { ExternalTaskActionPrefill } from "@/lib/externalTaskExecutor";
import { FEATURE_FLAGS } from "@/config/featureFlags";
import type { ModuleCaptureHandler } from "@/lib/capture/types";
import { cloudTaskId, PEOPLE_TASKS_PROVIDERS } from "../../../../supabase/functions/_shared/peopleTasksDomain";

type Prefill = PeopleTaskPrefill | ExternalTaskActionPrefill;
export const peopleTaskCaptureHandler: ModuleCaptureHandler<Prefill> = {
  tool: "propose_people_task_action",
  isEnabled: () => FEATURE_FLAGS.PEOPLE_TASKS_EXECUTOR_ENABLED,
  getRawText: proposal => proposal.tool === "propose_people_task_action" ? JSON.stringify(proposal.args) : "",
  extract: async (_raw, proposal, ctx) => {
    if (proposal.tool !== "propose_people_task_action") return null;
    const a = proposal.args;
    const kind = a.kind === "contact" ? "contact" : "task";
    const provider = PEOPLE_TASKS_PROVIDERS.find(p => p === a.provider && p.endsWith("contacts") === (kind === "contact")) || "auto";
    const allowed = kind === "contact" ? ["search", "create", "update"] : ["search", "create", "update", "complete", "reopen", "delete"];
    if (kind === "task" && provider !== "apple_reminders") {
      if (!ctx.ownerId || !ctx.sessionId || !proposal.action_id) return null;
      let listId: string | undefined, itemId: string | undefined;
      try {
        if (provider !== "auto" && a.list_id !== undefined) listId = cloudTaskId(a.list_id);
        if (provider !== "auto" && a.item_id !== undefined) itemId = cloudTaskId(a.item_id);
      } catch { return null; }
      if (itemId && !listId) return null;
      return { kind: "task", provider: provider === "google_tasks" || provider === "microsoft_todo" ? provider : "auto",
        action: allowed.includes(a.action) ? a.action : "search", action_id: proposal.action_id,
        ...(listId ? { list_id: listId } : {}), ...(itemId ? { item_id: itemId } : {}),
        ...(typeof a.query === "string" ? { query: a.query.slice(0, 200) } : {}),
        ...(typeof a.title === "string" ? { title: a.title.slice(0, 200) } : {}),
        ...(typeof a.notes === "string" ? { notes: a.notes.slice(0, 8000) } : {}),
        ...(a.due_date === null || typeof a.due_date === "string" ? { due_date: a.due_date } : {}),
        expected_user_id: ctx.ownerId, expected_session_id: ctx.sessionId } as ExternalTaskActionPrefill;
    }
    return { ...a, kind, provider, action: allowed.includes(a.action) ? a.action : "search", action_id: proposal.action_id };
  },
  renderModal: ({ open, prefill, onClose, onCreated }) => prefill?.kind === "task" && prefill.provider !== "apple_reminders"
    ? <ExternalTaskActionModal open={open} prefill={prefill as ExternalTaskActionPrefill} onClose={onClose} onCreated={onCreated} />
    : <PeopleTaskActionModal open={open} prefill={prefill as PeopleTaskPrefill | null} onClose={onClose} onCreated={onCreated} />,
};
